import RestService from './RestService';

const fetchOrderInfoService = async (uuid) => {
  try {
    const response = await RestService.get(`/api/v1/customer/detail?token=${uuid}}`);

    return { status: response.status.code, result: response.entity };
  } catch (error) {
    return { status: error.status.code, message: error.status.text };
  }
};

export default {
  fetchOrderInfoService
};



/** WEBPACK FOOTER **
 ** ./src/services/FetchOrderInfoService.js
 **/